import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { LAYOUT_HEIGHT } from "state/constants";


const NotFound = () => {
    const navigate = useNavigate();
    const theme = useTheme();       
    const textPrimaryColor = theme.palette.text.primary;
    const backgroundDefault = theme.palette.background.default;

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <Box 
            height={LAYOUT_HEIGHT}
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            textAlign="center"
            gap={2}
            sx={{ bgcolor: backgroundDefault, overflowY: "auto" }}
        >
            <Box 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                sx={{ fontSize: '6rem', color: '#ff6b6b' }}
            >
                <ErrorOutlineIcon sx={{ fontSize: '6rem' }} />
                <Typography variant="h2" sx={{ fontSize: '3rem', fontWeight: 600 }}>
                    404
                </Typography>
            </Box>
            <Typography variant="h5" sx={{ color: textPrimaryColor, fontWeight: 600 }}>
                Oops! Not Found
            </Typography>            
            <Button 
                color="primary" 
                onClick={handleGoHome} 
                sx={{ fontWeight: 600, textDecoration: "underline" }}
            >
                Go to Home Page
            </Button>
        </Box>
    );
};

export default NotFound;
